const KANBAN_DEFAULT_MODE_KEY = 'autoclever.kanban.defaultMode';

export const KANBAN_MODE_SERVICE = 'service';
export const KANBAN_MODE_DEALER = 'dealer';

const normalizeBoardMode = (value) =>
  value === KANBAN_MODE_DEALER ? KANBAN_MODE_DEALER : KANBAN_MODE_SERVICE;

export const getDefaultKanbanMode = () => {
  try {
    return normalizeBoardMode(window.localStorage.getItem(KANBAN_DEFAULT_MODE_KEY));
  } catch (_error) {
    return KANBAN_MODE_SERVICE;
  }
};

export const setDefaultKanbanMode = (value) => {
  const normalizedValue = normalizeBoardMode(value);

  try {
    window.localStorage.setItem(KANBAN_DEFAULT_MODE_KEY, normalizedValue);
  } catch (_error) {
    // Ignore storage write failures and continue using the normalized value.
  }

  return normalizedValue;
};
